export default __webpack_public_path__ + "img/da5ce253509ec40f3cce0c7097a7b178.png";